import { Card } from '@/shared/components/ui/Card';

export function DashboardSkeleton() {
  return (
    <div className="space-y-6">
      {/* Alert cards skeleton */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {[1, 2, 3, 4].map((i) => (
          <Card key={i} padding="md">
            <div className="animate-pulse flex space-x-3">
              <div className="w-8 h-8 bg-gray-200 rounded" />
              <div className="flex-1 space-y-3">
                <div className="h-4 bg-gray-200 rounded w-3/4" />
                <div className="h-3 bg-gray-200 rounded w-1/2" />
              </div>
            </div>
          </Card>
        ))}
      </div>

      {/* Usage card skeleton */}
      <Card padding="md">
        <div className="animate-pulse flex space-x-3">
          <div className="w-8 h-8 bg-gray-200 rounded" />
          <div className="flex-1 space-y-3">
            <div className="h-4 bg-gray-200 rounded w-1/4" />
            <div className="h-8 bg-gray-200 rounded w-1/3" />
          </div>
        </div>
      </Card>
    </div>
  );
}
